module.exports = __webpack_public_path__ + "img/sphere11-graph.3eb4ef79.png";